import gql from 'graphql-tag';

export const SEARCH_PAYMENTS = gql`
  query searchPayments ($idValue: ID!) {
    SearchPayments(id:$idValue) {
      id
    }
  }
`;

export const CREATE_PAYMENT = gql`
  mutation createPayment (
    $id: ID,
    $transactionDate: _Neo4jDateTimeInput,
    $type: String,
    $territoryCode: String,
    $value: Float,
    $unit: String
  ) {
  CreatePayment(
    id: $id,
    transactionDate: $transactionDate,
    type: $type,
    territoryCode: $territoryCode,
    value: $value,
    unit: $unit
  ) {
    id,
    transactionDate { formatted },
    type,
    territoryCode,
    value,
    unit
  }
}
`;

export const UPDATE_PAYMENT = gql`
  mutation updatePayment (
    $id: ID!,
    $transactionDate: _Neo4jDateTimeInput,
    $type: String,
    $territoryCode: String,
    $value: Float,
    $unit: String
  ) {
  UpdatePayment(
    id: $id,
    transactionDate: $transactionDate,
    type: $type,
    territoryCode: $territoryCode,
    value: $value,
    unit: $unit
  ) {
    id,
    transactionDate { formatted },
    type,
    territoryCode,
    value,
    unit
  }
}
`;

export const DELETE_PAYMENT = gql`
  mutation deletePayment (
    $id: ID!
  ) {
  DeletePayment(
    id: $id
  ) {
    id
  }
}
`;

// AddPaymentFor(
//   from: _PaymentInput!
//   to: _ContributionInput!
// ): _AddPaymentForPayload
// RemovePaymentFor(
//   from: _PaymentInput!
//   to: _ContributionInput!
// ): _RemovePaymentForPayload
// }
